module.exports = __webpack_public_path__ + "static/mexc-logo-c943c43937381dd8eada76fedbd96928.png";